<template>
  <div class="fullheight">
    <el-tabs class="aa" v-model="activeName" @tab-click="handleClick" v-if="tenantId && tenantId != -1">
      <!-- v-if="tenantId && tenantId != -1" -->
      <el-tab-pane label="我的模板" name="first"></el-tab-pane>
      <el-tab-pane label="模板库" name="second"></el-tab-pane>
    </el-tabs>
    <el-container
      class="fullheight"
      style="border: 1px solid #eee"
      :style="{
        height: height,
        marginTop: '20px'
      }"
    >
      <el-aside class="fullheight" :width="width" v-show="asideShow">
        <fe-sys-type-tree
          class="fe-sys-type-tree"
          highlight-current
          ref="ecoDataDicTree"
          :support-filter="supportFilter"
          :default-expand-all="isExpand"
          :tabIndex="activeName"
          expand-on-click-node="false"
          @node-click="handleNodeClick"
          buildKey
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span :class="[checkCanEdit() ? 'show-ellipsis-spec' : 'show-ellipsis-spec-len']" :title="node.label">{{ `${node.label}` }}</span>
            <template v-if="checkCanEdit()">
              <span>{{ !data.state ? '启用' : '禁用' }}</span>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <!-- <i class="el-icon-more" title="更多操作" /> -->
                  <img src="@/assets/img/iconMore.png" class="iconMore" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-edit" :command="{ node: node, data, action: 'addChild' }">新增工序</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-edit" :command="{ node: node, data, action: 'edit' }">编辑模板</el-dropdown-item>
                  <!-- <el-dropdown-item
                    icon="el-icon-delete"
                    :command="{ node: node, data, action: 'delete' }"
                    >删除模板</el-dropdown-item
                  > -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template v-else>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <!-- <i class="el-icon-more" title="更多操作" /> -->
                  <img src="@/assets/img/iconMore.png" class="iconMore" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-edit" :command="{ node: node, data, action: 'referTemplate' }">引用模板</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </span>
        </fe-sys-type-tree>
      </el-aside>
      <el-container>
        <el-main class="fullheight">
          <el-scrollbar class="dic-data-scrollbar">
            <eco-tree
              :data="dicDatas"
              node-key="id"
              :props="defaultProps"
              :support-filter="false"
              :expand-on-click-node="false"
              :default-expand-all="isExpandDic"
              ref="dicDataTree"
            >
              <!-- 作用域插槽：插槽prop -->
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <!-- <span>{{ data.sortNum + "、" }}</span> -->
                <span class="show-ellipsis" :title="node.label">
                  {{ node.label }}
                </span>
                <el-dropdown @command="handleCommand" v-if="checkCanEdit()">
                  <span class="el-dropdown-link">
                    <!-- <i class="el-icon-more" title="更多操作" /> -->
                    <img src="@/assets/img/iconMore.png" class="iconMore" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-edit" v-if="!data.parentId" :command="{ node: node, data, action: 'dicAdd' }">新增子工序</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-edit" v-if="!data.parentId" :command="{ node: node, data, action: 'editChild' }">编辑</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-delete" v-if="!data.parentId" :command="{ node: node, data, action: 'dicDelete' }">删除</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-edit" v-if="data.parentId" :command="{ node: node, data, action: 'dicEdit' }">编辑</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-delete" v-if="data.parentId" :command="{ node: node, data, action: 'dicDelete' }">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </eco-tree>
          </el-scrollbar>
        </el-main>
      </el-container>
      <div class="i_export">
        <el-button v-loading="loading" @click="addKey" v-if="checkCanEdit()">新增模板</el-button>
      </div>
    </el-container>
    <!-- 新增模板 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dialogVisible" :before-close="handleClose" append-to-body>
      <el-form :model="sysType" data-vv-scope="sysTypeForm" style="padding: 20px">
        <eco-form-item label="模板名称" label-width="100px">
          <eco-input v-model="sysType.name" autocomplete="off" :validate="{ required: true, max: 20 }"></eco-input>
        </eco-form-item>
        <eco-form-item label="状态" label-width="100px">
          <eco-radio
            validate="required"
            v-model="sysType.state"
            :options="[
              { key: '0', value: '启用' },
              { key: '1', value: '禁用' }
            ]"
          />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <fe-submit-button :url="saveSysTypeUrl" :model="sysType" scope-name="sysTypeForm" @error-save-data="errorSaveData" @after-save-data="afterSaveData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑模板 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dialogVisibleEdit" :before-close="handleClose" append-to-body>
      <el-form :model="editSysType" data-vv-scope="editSysTypeForm" style="padding: 20px">
        <eco-form-item label="模板名称" label-width="100px">
          <eco-input v-model="editSysType.name" autocomplete="off" :validate="{ required: true, max: 20 }"></eco-input>
        </eco-form-item>
        <eco-form-item label="状态" label-width="100px">
          <eco-radio
            validate="required"
            v-model="editSysType.state"
            :options="[
              { key: '0', value: '启用' },
              { key: '1', value: '禁用' }
            ]"
          />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisibleEdit = false">取 消</el-button>
        <fe-submit-button
          :url="saveSysTypeUrlEdit"
          :model="editSysType"
          scope-name="editSysTypeForm"
          @error-save-data="errorSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 新增工序 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="dicTitle" :visible="dialogVisibleChild" :before-close="handleClose" append-to-body>
      <el-form :model="dicDataFirst" data-vv-scope="dicDataFirstForm" style="padding: 20px">
        <eco-form-item label="工序顺序" label-width="85px">
          <eco-input
            v-model="dicDataFirst.sortNum"
            autocomplete="off"
            placeholder="请输入工序顺序"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <!-- <eco-form-item label="工序编号" label-width="85px">
          <eco-input
            v-model="dicDataFirst.key"
            v-pinyin="dicDataFirst.name"
            autocomplete="off"
            :validate="{ required: true, alpha_num: true, max: 200 }"
          ></eco-input>
        </eco-form-item> -->
        <eco-form-item label="工序名称" label-width="85px">
          <eco-input v-model="dicDataFirst.name" autocomplete="off" :validate="{ required: true, max: 20 }" placeholder="请输入工序名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisibleChild = false">取 消</el-button>
        <fe-submit-button
          :url="saveDicDataUrl"
          :model="dicDataFirst"
          scope-name="dicDataFirstForm"
          @error-save-data="errorSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑工序 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="dicTitle" :visible="dialogVisibleChildEdit" :before-close="handleClose" append-to-body>
      <el-form :model="editDicDataFirst" data-vv-scope="editDicDataForm" style="padding: 20px">
        <eco-form-item label="工序顺序" label-width="85px">
          <eco-input
            v-model="editDicDataFirst.sortNum"
            autocomplete="off"
            placeholder="请输入工序顺序"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <!-- <eco-form-item label="工序编号" label-width="85px">
          <eco-input
            v-model="editDicData.key"
            v-pinyin="editDicData.name"
            autocomplete="off"
            :validate="{ required: true, alpha_num: true, max: 200 }"
          ></eco-input>
        </eco-form-item> -->
        <eco-form-item label="工序名称" label-width="85px">
          <eco-input v-model="editDicDataFirst.name" autocomplete="off" :validate="{ required: true, max: 20 }" placeholder="请输入工序名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisibleChildEdit = false">取 消</el-button>
        <fe-submit-button
          :url="saveDicDataUrlEdit"
          :model="editDicDataFirst"
          scope-name="editDicDataForm"
          @error-save-data="errorSaveData"
          @after-save-data="afterSaveData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 新增子工序 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="dicTitle" :visible="dicDialogVisible" :before-close="handleClose" append-to-body>
      <el-form :model="dicData" data-vv-scope="editDic" style="padding: 20px">
        <eco-form-item label="工序名称" label-width="100px">
          <eco-input v-model="dicData.parentName" autocomplete="off" disabled> </eco-input>
        </eco-form-item>
        <eco-form-item label="子工序顺序" label-width="100px">
          <eco-input
            v-model="dicData.sortNum"
            autocomplete="off"
            placeholder="请输入子工序顺序"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <!-- <eco-form-item label="子工序编号" label-width="100px">
          <eco-input
            v-model="dicData.key"
            v-pinyin="dicData.name"
            autocomplete="off"
            :validate="{ required: true, alpha_num: true, max: 200 }"
          ></eco-input>
        </eco-form-item> -->
        <eco-form-item label="子工序名称" label-width="100px">
          <eco-input v-model="dicData.name" autocomplete="off" :validate="{ required: true, max: 20 }" placeholder="请输入子工序名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dicDialogVisible = false">取 消</el-button>
        <fe-submit-button :url="saveDicDataUrl" :model="dicData" scope-name="editDic" @error-save-data="errorSaveDicData" @after-save-data="afterSaveDicData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑子工序 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="dicTitle" :visible="editDicDialogVisible" :before-close="handleCloseEdit" append-to-body>
      <el-form :model="editDicData" data-vv-scope="editDic1" style="padding: 20px">
        <eco-form-item label="工序名称" label-width="100px">
          <eco-input v-model="editDicData.parentName" autocomplete="off" disabled></eco-input>
        </eco-form-item>
        <eco-form-item label="工序顺序" label-width="100px">
          <eco-input
            v-model="editDicData.sortNum"
            autocomplete="off"
            placeholder="请输入工序顺序"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <!-- <eco-form-item label="子工序编号" label-width="100px">
          <eco-input
            v-model="editDicData.key"
            v-pinyin="editDicData.name"
            autocomplete="off"
            :validate="{ required: true, alpha_num: true, max: 200 }"
          ></eco-input>
        </eco-form-item> -->
        <eco-form-item label="子工序名称" label-width="100px">
          <eco-input v-model="editDicData.name" autocomplete="off" :validate="{ required: true, max: 20 }" placeholder="请输入子工序名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="editDicDialogVisible = false">取 消</el-button>
        <fe-submit-button
          :url="saveDicDataUrlEdit"
          :model="editDicData"
          scope-name="editDic1"
          @error-save-data="errorSaveDicData"
          @after-save-data="afterSaveDicData"
          >{{ $t('eip.common.save') }}</fe-submit-button
        >
      </div>
    </eco-sidebar-dialog>
    <!-- 引用模板 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="referVisible" :before-close="handleReferClose" append-to-body>
      <el-form :model="referType" data-vv-scope="referTypeForm" style="padding: 20px">
        <eco-form-item label="模板名称" label-width="100px">
          <eco-input v-model="referType.name" autocomplete="off" :validate="{ required: true, max: 20 }"></eco-input>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="referVisible = false">取 消</el-button>
        <fe-submit-button :url="saveReferTypeUrl" :model="referType" scope-name="referTypeForm" @after-save-data="afterSaveRefData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
import styles from '@/assets/css/element-variables.scss'
import helendesign from '@/api/helendesign.js'
const feSysTypeTree = () => import('@/components/common/FeSysTypeTree.vue')
export default {
  components: {
    feSysTypeTree
  },
  props: {
    width: {
      type: String,
      default: styles.aside_width
    },
    supportFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeName: 'first',
      height: '100%',
      dicData: {
        // key: "", //编号
        name: '', // 子工序名称
        parentId: '', // 父id
        templateId: '',
        sortNum: '' // 工序顺序
      },
      editDicData: {},
      editDicDataFirst: {
        name: '',
        sortNum: ''
      },
      dicParentId: '', //存储数据字典父类id用于刷新数据字典树
      title: '新增施工模板',
      dicTitle: '新增科目',
      asideShow: true,
      isExpand: true,
      isExpandDic: true,
      dialogVisible: false,
      dialogVisibleEdit: false,
      dialogVisibleChild: false,
      dialogVisibleChildEdit: false,
      dicDialogVisible: false,
      editDicDialogVisible: false,
      referVisible: false,
      dialogImportVisible: false,
      fullscreenLoading: false,
      fileList: [],
      sysType: {
        state: '0',
        name: ''
      },
      dicDataFirst: {
        name: '',
        sortNum: ''
      },
      referType: {
        name: '',
        sysTemplateId: ''
      },
      editSysType: {
        name: ''
      },
      treeData: [],
      defaultProps: {
        children: 'processInfoList',
        label: 'name'
      },
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      bpmForm: {
        key: '',
        bos: '',
        desc: ''
      },
      dicDatas: [],
      loading: false,
      maxlength: 20,
      tenantId: '',
      sortNum: ''
    }
  },
  computed: {
    // 新增模板
    saveSysTypeUrl: function () {
      return `${window.context.work}/planning/process_template/add_my_template/`
    },
    // 编辑模板
    saveSysTypeUrlEdit: function () {
      return `${window.context.work}/planning/process_template/edit_my_template/`
    },
    // 引用模板
    saveReferTypeUrl: function () {
      return `${window.context.work}/planning/process_template/sys_template_to_self/`
    },
    // 新增工序/子工序
    saveDicDataUrl: function () {
      return `${window.context.work}/planning/process_detail_template/add_process/`
    },
    // 编辑子工序
    saveDicDataUrlEdit: function () {
      return `${window.context.work}/planning/process_detail_template/edit_process/`
    }
  },
  mounted() {
    this.tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
    this.height = this.tenantId && this.tenantId != -1 ? 'calc(100% - 56px)' : '100%'
    if (this.tenantId && this.tenantId != -1) {
      this.activeName = 'first'
    } else {
      this.activeName = 'second'
    }
  },
  methods: {
    // tab切换
    handleClick(tab) {
      this.templateData = []
      this.activeName = tab.name
      this.$nextTick(() => {
        this.$refs.ecoDataDicTree.loadData()
        this.dicDatas = []
      })
    },
    addKey() {
      this.dialogVisible = true
      this.title = '新增施工模板'
    },
    handleNodeClick(node) {
      this.dicLoadData(node.id)
    },
    dicLoadData(id) {
      if (this.activeName === 'first') {
        helendesign.getTemplateDetail(id).then((data) => {
          if (data) {
            //数据转换成树 children格式
            this.dicParentId = id
            this.dicDatas = data.value
          }
        })
      } else {
        helendesign.getPublicTemplateDetail(id).then((data) => {
          if (data) {
            //数据转换成树 children格式
            this.dicParentId = id
            this.dicDatas = data.value
          }
        })
      }
    },
    handleCommand(command) {
      let data = command.data
      let action = command.action
      let newDicdata
      switch (action) {
        case 'add':
          this.title = '新增施工模板'
          this.dialogVisible = true
          break
        case 'edit':
          newDicdata = {}
          this.title = '编辑施工模板'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.editSysType = newDicdata
          this.editSysType.state = this.editSysType.state.toString()
          this.dialogVisibleEdit = true
          break
        case 'addChild':
          this.dicTitle = '新增工序'
          this.dialogVisibleChild = true
          this.dicDataFirst.templateId = data.id
          break
        case 'editChild':
          newDicdata = {}
          this.dicTitle = '编辑工序'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.editDicDataFirst = newDicdata
          this.dialogVisibleChildEdit = true
          break
        case 'import':
          newDicdata = {}
          Object.assign(newDicdata, data)
          this.sysType = newDicdata
          this.dialogImportVisible = true
          break
        case 'delete':
          if (data.id) {
            this.$confirm(`是否确定删除 [${data.name}]  及其子分类（包含分类下数据）?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              helendesign
                .delCostAccountType(data.id)
                .then((resp) => {
                  let data = resp
                  if (data.state) {
                    this.$message({
                      type: 'success',
                      message: data.message || '删除成功'
                    })
                    this.$refs.ecoDataDicTree.loadData()
                    this.dicDatas = null
                    this.syncDicTree()
                  } else {
                    // this.$message.error(data.message || "删除失败");
                  }
                })
                .catch(() => {
                  this.dialogVisible = false
                })
            })
          }
          break
        case 'dicAdd': //数据字典添加
          this.dicTitle = '新增子工序'
          this.dicDialogVisible = true
          this.dicData.parentName = data.name
          this.dicData.parentId = data.id
          this.dicData.templateId = this.dicParentId
          break
        case 'dicDelete':
          if (data.id) {
            this.$confirm(`是否确定删除 [${data.name}] ?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              helendesign
                .delProcessDetailTemplate({ id: data.id })
                .then((data) => {
                  if (data.state) {
                    this.$message({
                      type: 'success',
                      message: data.message || '删除成功'
                    })
                    this.$refs.ecoDataDicTree.loadData()
                    this.syncDicTree()
                  } else {
                    // this.$message.error(data.message || "删除成功");
                  }
                })
                .catch(() => {
                  this.dicDialogVisible = false
                })
            })
          }
          break
        case 'dicEdit':
          newDicdata = {}
          this.dicTitle = '编辑子工序'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.editDicData = newDicdata
          this.editDicData.id = data.id
          this.editDicDialogVisible = true
          this.editDicData.parentName = this.dicDatas.find((x) => x.id === data.parentId).name
          break
        case 'referTemplate':
          this.title = '引用模板'
          newDicdata = {}
          Object.assign(newDicdata, data)
          //   this.referType = newDicdata;
          this.referType.sysTemplateId = newDicdata.id
          this.referType.name = newDicdata.name
          this.referVisible = true
          break

        default:
          break
      }
    },
    handleReferClose() {
      this.referVisible = false
    },
    syncTree() {
      this.$refs.ecoDataDicTree.loadData()
    },
    syncDicTree() {
      if (this.dicParentId) {
        this.dicLoadData(this.dicParentId)
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisibleChild = false
      this.dialogVisibleEdit = false
      this.dialogVisibleChildEdit = false
      this.dicDialogVisible = false
    },
    handleCloseEdit() {
      this.editDicDialogVisible = false
    },
    afterSaveData() {
      this.$refs.ecoDataDicTree.loadData()
      if (this.dicParentId) {
        this.dicLoadData(this.dicParentId)
      }
      // 编辑
      if (this.editSysType.id || this.editDicDataFirst.id) {
        // 模版
        this.editSysType = {}
        this.dialogVisibleEdit = false
        // 一级工序
        this.editDicDataFirst = {}
        this.dialogVisibleChildEdit = false
        return
      }

      // 新增
      // 模版
      this.sysType.name = ''
      this.dicDataFirst.state = ''
      // 一级工序
      this.dicDataFirst.name = ''
      this.dicDataFirst.sortNum = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .finally(() => {
          this.dialogVisible = false
          this.dialogVisibleEdit = false
          this.dialogVisibleChild = false
          this.dialogVisibleChildEdit = false
        })
    },
    errorSaveData() {
      // 后端异常处理
      // 模版
      this.sysType.name = ''
      this.dicDataFirst.state = ''
      // 一级工序
      this.dicDataFirst.name = ''
      this.dicDataFirst.sortNum = ''
    },
    afterSaveRefData() {
      this.$refs.ecoDataDicTree.loadData()
      this.referVisible = false
    },
    afterSaveDicData() {
      this.$refs.ecoDataDicTree.loadData()
      if (this.dicParentId) {
        this.dicLoadData(this.dicParentId)
      }
      // 子工序
      if (this.editDicData.id) {
        this.editDicDialogVisible = false
        return
      }
      // 二级工序
      this.dicData.name = ''
      this.dicData.sortNum = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.dicDialogVisible = false
          this.editDicDialogVisible = false
        })
    },
    errorSaveDicData() {
      // 后端异常处理
      // 模版
      // 二级工序
      this.dicData.name = ''
      this.dicData.sortNum = ''
    },
    beforeUpload() {
      this.fullscreenLoading = true
    },
    submitImport() {
      if (!this.$refs.upload.uploadFiles || this.$refs.upload.uploadFiles.length == 0) {
        this.$message.warning('请上传数据字典文件进行导入')
        return false
      }
      if (this.sysType.id && this.sysType.id == '') {
        this.$message.warning('请选择某一个分类进行导入!')
      }
      this.$refs.upload.submit()
    },
    cancelConfirm() {
      this.$refs.upload.clearFiles()
      this.fileList = []
      this.dialogImportVisible = false
    },
    //下载模板
    downloadTemplate() {
      window.location.href = '/static/excel/数据字典模板.xls'
    },
    /**
     * 判断是否能编辑
     */
    checkCanEdit() {
      if (this.activeName === 'second') {
        return this.tenantId === '-1'
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0px;
}
>>> .navbar-collapse {
  position: absolute;
  top: 41%;
  cursor: pointer;
  z-index: 999;
  width: 20px;
}

>>> .el-dropdown {
  display: none;
}

>>> .el-tree-node__content:hover .el-dropdown {
  display: inline-block;
}

>>> .navbar-collapse:hover {
  transform: scale(1.1) translateY(2px);
}

>>> .navbar-collapse:hover .navbar-collapse-arrow {
  color: #333333;
}

>>> .navbar-collapse-arrow {
  position: absolute;
  top: 38%;
  right: -3px;
  font-size: 18px;
  color: #a8a8a8;
}

>>> .navbar-collapse-bg {
  -webkit-transition: all 0.12s ease;
  height: 50px;
  border-bottom: 8px solid transparent;
  border-right: none;
  border-left: 12px solid #ebebeb;
  border-top: 8px solid transparent;
  opacity: 0.9;
}
.el-aside-footer {
  position: absolute;
  bottom: 21px;
}
.i_export {
  margin-top: 15px;
  margin-right: 15px;
}
>>> .custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-node i {
  visibility: hidden;
  font-weight: bold;
}

.custom-tree-node:hover i {
  visibility: visible;
}

.dic-data-scrollbar {
  width: 250px;
  height: 100%;
  border-right: 1px solid #eee;
}

.dic-data-scrollbar >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.show-ellipsis-spec {
  width: calc(100% - 52px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.show-ellipsis-spec-len {
  width: calc(100% - 25px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 14px;
  padding-right: 8px;
}
/deep/.aa > .el-tabs__header {
  margin: 0;
}
</style>
